export const activityPriorities = {
    HIGH: { value: 1, label: 'HIGH' },
    MEDIUM: { value: 2, label: 'MEDIUM' },
    LOW: { value: 3, label: 'LOW' },
};